import { render } from "./FormSelectIconLabelFieldComponent.vue?vue&type=template&id=6b5ba518&scoped=true"
import script from "./FormSelectIconLabelFieldComponent.vue?vue&type=script&lang=js"
export * from "./FormSelectIconLabelFieldComponent.vue?vue&type=script&lang=js"

import "./FormSelectIconLabelFieldComponent.vue?vue&type=style&index=0&id=6b5ba518&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b5ba518"]])

export default __exports__